import { useEffect } from 'react'

/** The home page's title: the name, and what it is (also in index.html and the prerender). */
export const HOME_TITLE = 'GrimoireCodexDB: the community database of tabletop RPG books and systems'

/** Set the document title: "<page> · GrimoireCodexDB", or the home page's title for null. */
export function useTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (title === undefined) return
    document.title = title ? `${title} · GrimoireCodexDB` : HOME_TITLE
  }, [title])
}
